import React from 'react'

import Alert from 'components/ui/alert'
import InlineLink from 'components/ui/inline-link'

const InsightsLimitedAlert = (): React.ReactNode => (
  <Alert icon="warning" status="warning">
    Analytics offer powerful insights into your activity on DISCO. To access all
    your Analytics, <InlineLink to="/pricing">upgrade to Pro.</InlineLink>
  </Alert>
)

export default InsightsLimitedAlert
